import * as _ from 'lodash';

import type { Project } from '../../../../types';

const projectReportsSettingsFields = [
  'defaultSavedOptionLicensingReport',
  'defaultSavedOptionSbom',
] as const;
export type ProjectReportsSettings = Pick<Project, typeof projectReportsSettingsFields[number]>;

export const pickReportsSettingsFromProject = (project: Project): ProjectReportsSettings =>
  _.pick(project, projectReportsSettingsFields);
